const TOKENS_BY_USER_REQUEST = 'TOKENS_BY_USER_REQUEST';
const TOKENS_BY_USER_SUCCESS = 'TOKENS_BY_USER_SUCCESS';
const TOKENS_BY_USER_FAIL = 'TOKENS_BY_USER_FAIL';

const TOKENS_CREATE_BY_USER_REQUEST = 'TOKENS_CREATE_BY_USER_REQUEST';
const TOKENS_CREATE_BY_USER_SUCCESS = 'TOKENS_CREATE_BY_USER_SUCCESS';
const TOKENS_CREATE_BY_USER_FAIL = 'TOKENS_CREATE_BY_USER_FAIL';

export const tokenActions = {
  TOKENS_BY_USER_REQUEST,
  TOKENS_BY_USER_SUCCESS,
  TOKENS_BY_USER_FAIL,
  TOKENS_CREATE_BY_USER_SUCCESS,
  TOKENS_CREATE_BY_USER_REQUEST,
  TOKENS_CREATE_BY_USER_FAIL
}
